(() => {
  const SELECTOR = "[data-client-testimonials-marquee]";

  function cloneEnough(row) {
    const track = row.querySelector(".client-testimonials__track");
    const source = track?.querySelector("[data-marquee-source]");
    if (!track || !source) return;

    track.querySelectorAll('[data-marquee-clone="true"]').forEach(node => node.remove());

    const sourceWidth = source.getBoundingClientRect().width;
    const viewportWidth = row.getBoundingClientRect().width;

    if (!sourceWidth || !viewportWidth) return;

    // One identical group is the exact animation distance.
    row.style.setProperty("--ct-loop-width", `${sourceWidth}px`);

    // Add enough identical copies to prevent any blank gap on wide screens.
    const copiesNeeded = Math.max(2, Math.ceil(viewportWidth / sourceWidth) + 2);

    for (let i = 0; i < copiesNeeded; i += 1) {
      const clone = source.cloneNode(true);
      clone.removeAttribute("data-marquee-source");
      clone.setAttribute("data-marquee-clone", "true");
      clone.setAttribute("aria-hidden", "true");

      // Duplicated theme-editor attributes can confuse the editor, so strip them.
      clone.querySelectorAll("[data-shopify-editor-block]").forEach(el => {
        el.removeAttribute("data-shopify-editor-block");
      });

      track.appendChild(clone);
    }

    row.dataset.marqueeReady = "true";
  }

  function initSection(section) {
    section.querySelectorAll("[data-marquee-row]").forEach(cloneEnough);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 160);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  window.addEventListener("resize", onResize, { passive: true });

  // Shopify theme editor support.
  document.addEventListener("shopify:section:load", event => {
    const section = event.target?.querySelector?.(SELECTOR) ||
      (event.target?.matches?.(SELECTOR) ? event.target : null);

    if (section) initSection(section);
  });
})();